import { useCallback } from 'react';
import { Location } from 'history';
import { removeAutoLoginParams } from '../../lib/url';
import { SsoProvider } from './useDomainSettings';

export const useCreateProviderUrl = ({
  referrer,
  domain,
  popupRedirect,
}: {
  referrer: Location<unknown> | undefined;
  domain: string;
  popupRedirect?: boolean;
}) => {
  // Strip the autologin params so the IdP returns to a clean URL — otherwise the
  // param is retained in router state and a later logout re-triggers autologin.
  const redirectUrl = referrer
    ? `${document.location.origin}${referrer.pathname}${removeAutoLoginParams(
        referrer.search
      )}${referrer.hash}`
    : undefined;

  const getRedirectUrl = useCallback(
    (sendRedirectUrl: boolean) => {
      if (popupRedirect) {
        return `${document.location.origin}/sso-callback`;
      }
      return redirectUrl ?? (sendRedirectUrl ? document.location.origin : '');
    },
    [redirectUrl, popupRedirect]
  );

  const createProviderUrl = useCallback(
    (authProvider: SsoProvider) => {
      const resolvedRedirectUrl = getRedirectUrl(authProvider.sendRedirectUrl);
      const redirectUrlParam = resolvedRedirectUrl
        ? { redirect_url: resolvedRedirectUrl }
        : undefined;

      const search = new URLSearchParams({
        domain,
        sso_provider: `${authProvider.id}`,
        ...redirectUrlParam,
      });

      return `${authProvider.apiUrl}/oauth/authorize?${search.toString()}`;
    },
    [domain, getRedirectUrl]
  );

  return createProviderUrl;
};
